'use client'

import FloatMessages from "@/components_mobile/float/messages";
import api from "@/util/api";
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "./authContext";
import getQueryString from "@/util/queryString";
import { messageListTypes, messageTypes, messageFetchType } from "@/type/user";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

interface messageContextTypes {
    messageShow: boolean
    SetMessageShow: (show: boolean) => void
    messageType: messageFetchType
    SetMessageType: (type: messageFetchType) => void
    MessageRead: (id: number) => void
    messageCount: number
    messageList: messageListTypes[]
    totalCount: number
    page: number
    setPage: Function
    fetchData:(type:messageFetchType, page: number)=>void
    showSponMsg: boolean
    setshowSponMsg: (show: boolean) => void
    appPush: boolean
}
const messageContextTypesDefault = {
    messageShow: false,
    SetMessageShow: () => { },
    messageType: 'user' as messageFetchType,
    SetMessageType: () => { },
    MessageRead: () => { },
    messageCount: 0,
    messageList: [],
    totalCount: 1,
    page: 1,
    setPage: () => { },
    fetchData:()=>{},
    showSponMsg: false,
    setshowSponMsg: () => { },
    appPush: false,
}
export const MessageContext = createContext<messageContextTypes>(messageContextTypesDefault)
export default function MessageProvider({ children }: { children: ReactNode }) {
    const { user } = useContext(AuthContext)
    const [messageType, setMessageType] = useState<messageFetchType>('user')
    const [messageShow, setMessageShow] = useState<boolean>(false)
    const [showSponMsg, setshowSponMsg] = useState<boolean>(true)
    const [messageCount, setmessageCount] = useState<number>(0)
    const [messageList, setMessageList] = useState<messageListTypes[]>([])

    
    const [appPush, setAppPush] = useState<boolean>(false)

    const [page, setPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(1)
    const perPage = 5

    const searchParam = useSearchParams()
    const pathName = usePathname()
    const router = useRouter()

    function SetMessageShow(show: boolean) {
        setMessageShow(show)
    }
    function SetMessageType(type: messageFetchType) {
        setMessageType(type)
    }

    function MessageRead(message_id: number) {
        if (!user.is_authenticated) return;

        const formData = new FormData()
        formData.set('username', user.id)
        formData.set('id', `${message_id}`)

        api(`/api/${messageType}/message/read/`, { method: 'POST', body: formData })
            .then(res => res.json())
            .then(({ status_code }) => {
                if (status_code == 200) {
                    setMessageList(prevList =>
                        prevList.map(el =>
                            el.id === message_id ? { ...el, is_read: true } : el
                        )
                    );
                }
            })

    }

    function fetchData(type:messageFetchType, page: number) {
        if (!user.is_authenticated) return;

        const queryString = {
            username: user.id,
            // username: 'han',
            page: page,
            page_count: perPage
        }
        let url = `/api/${type}/message/`
        if(type == "push"){
            url = "/api/verified/pushlog/"
        }
        api(url + getQueryString(queryString))
            .then(res => res.json())
            .then(({ data }) => {
                setMessageList(data.objects.filter((el: messageListTypes) => {
                    if(type != "push"){
                        // 스폰TV쪽지, 스폰업체쪽지
                        return el.is_deleted
                    }else{
                        // 푸시알림
                        return true
                    }
                }))
                setTotalCount(data.total_count)
            })
    }

    useEffect(() => {
        fetchData(messageType, page)
    }, [page])
    
    useEffect(() => {
        fetchData(messageType, 1)
    }, [messageType])

    // useEffect(()=> {
    //     const mesaageShowGetParams = searchParam.get('msg')
    //     // console.log("***", mesaageShowGetParams)
    //     if(mesaageShowGetParams && mesaageShowGetParams == 'True' && user.is_authenticated){
    //         setMessageShow(true)
    //         router.replace(pathName)
    //     }
    // }, [searchParam, user])


    // 왜 처리를 msg 하나만 해두셨으까아~?
    const executed = useRef(false);

    useEffect(() => {

        // console.log("■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■")

        // console.log("■■ executed-1 : ", executed.current)
        // if (executed.current) return;
        // executed.current = true;

        const mesaageShowGetParams = searchParam.get('msg')
        const vmsgParam = searchParam.get('vmsg')

        // console.log("■■ mesaageShowGetParams : ", mesaageShowGetParams)
        // console.log("■■ vmsgParam : ", vmsgParam)
        // console.log("■■ window.location.href : ", window.location.href);
        // console.log("■■ window.location.search : ", window.location.search);
        // console.log("■■ window.location.origin : ", window.location.origin);
        // console.log("■■ pathName : ", pathName);




        // if (mesaageShowGetParams && mesaageShowGetParams == 'True' && user.is_authenticated) {
        //     setMessageShow(true)
        //     router.replace(pathName)
        // }

        if ((mesaageShowGetParams === 'True' || vmsgParam === 'True') && user.is_authenticated) {
            if (!executed.current){
                executed.current = true;
                console.log("■■ MESSAGE ----------------------------- ");
                setAppPush(true)
                setMessageShow(true)
                setMessageType(mesaageShowGetParams === 'True' ?"user" : "verified")
                setshowSponMsg(mesaageShowGetParams === 'True' ? true : false)

                
                // if (mesaageShowGetParams === 'True') {
                //     setshowSponMsg(true);  
                // } else if (vmsgParam === 'True') {
                //     setshowSponMsg(false);   
                // }
                    
            }
            const cleanUrl = window.location.origin + pathName;
            router.replace(cleanUrl);
        }


        if (typeof window !== "undefined" && navigator.serviceWorker) {
            const onMessage = (event: MessageEvent) => {
                if (event.data?.type === "OPEN_MESSAGE" && user.is_authenticated) {
                    setMessageShow(true)
            }
        }
        navigator.serviceWorker.addEventListener("message", onMessage)
        
        // console.log("■■ executed-2 : ", executed.current)

        // console.log("■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■")

        // cleanup
        return () => navigator.serviceWorker.removeEventListener("message", onMessage)
    }
}, [searchParam, user])

    const returnProps = {
        messageShow,
        SetMessageShow,
        messageType,
        SetMessageType,
        MessageRead,
        messageCount,
        messageList,
        totalCount,
        page,
        setPage,
        fetchData,
        showSponMsg,
        setshowSponMsg,
        appPush,
    }
    return (
        <MessageContext.Provider value={returnProps}>{children}
            <FloatMessages />
        </MessageContext.Provider>
    )
}